import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { User } from '../../../clients/aasServerClient.generated';
import { currentUser, isLoggedInAs } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';
import UserImage from '../../common/UserImage';
import AliasIndicator from './AliasIndicator';

interface Props extends LocalizeContextProps, RouteComponentProps {
    isLoggedInAs: boolean;
    currentUser?: User;
}

class UserIndicator extends React.Component<Props> {
    public render() {
        const user = this.props.currentUser;

        let username = '\xa0';
        if (user) {
            // tslint:disable-next-line:prefer-conditional-expression
            if (user.first_name && user.last_name !== '') {
                username = user.first_name + ' ' + user.last_name;
            } else {
                username = user.email || user.username || '\xa0';
            }
        }

        return (
            <li className={`profile ${this.props.isLoggedInAs ? 'alias' : ''}`}>
                {this.props.isLoggedInAs ? <AliasIndicator /> : null}
                <Link
                    className="profile-link"
                    to={{
                        pathname: '/select-app',
                        state: { from: this.props.location }
                    }}
                >
                    <UserImage user={this.props.currentUser} size="m" className="mr-2" />

                    < div className="inline-block" >
                        <h4 className="profile-name">
                            {username}
                        </h4>
                        <h4><small>{user?.email || '\xa0'}</small></h4>
                    </div>

                    {/* <h4 className="float-right profile-angle">
                        <FontAwesomeIcon icon={['fal', 'angle-right']} />
                    </h4> */}
                </Link>
            </li >
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    currentUser: currentUser(state),
    isLoggedInAs: isLoggedInAs(state)
});

export default connect(mapStateToProps)(withLocalize(withRouter(UserIndicator)));